import type { ServiceCategory } from '../lib/pricebook/pricebook';

export type ServiceCopyCategory = Extract<ServiceCategory, 'platform' | 'marketing' | 'assets_design'>;

export type ServiceCopy = {
  readonly eyebrow: string;
  readonly title: string;
  readonly ctaLabel: string;
  readonly ctaTo: string;
  readonly lead: string;
  readonly points: ReadonlyArray<{
    readonly title: string;
    readonly body: string;
  }>;
};

export const SERVICE_COPY_BY_CATEGORY: Record<ServiceCopyCategory, ServiceCopy> = {
  marketing: {
    eyebrow: 'Managed Marketing',
    title: 'Growth programs built to compound over time.',
    ctaLabel: 'Build Your Package',
    ctaTo: '/services/managed-marketing',
    lead:
      'Managed Marketing is for brands that need consistent acquisition support across search, paid campaigns, content, and reporting without assembling a full in-house team.',
    points: [
      {
        title: 'Search visibility',
        body: 'Technical SEO, on-page improvements, local search support, and content direction built around discoverability.',
      },
      {
        title: 'Campaign execution',
        body: 'Paid media management, social campaign support, and creative coordination across active channels.',
      },
      {
        title: 'Performance clarity',
        body: 'Reporting, analytics review, and ongoing optimization decisions tied to business goals instead of vanity metrics.',
      },
    ],
  },
  assets_design: {
    eyebrow: 'Assets & Design',
    title: 'Creative systems that make execution faster.',
    ctaLabel: 'Build Your Package',
    ctaTo: '/services/assets-design',
    lead:
      'Assets & Design is for teams that need high-volume creative output, sharper landing pages, and a more unified visual system for campaigns, websites, and brand touchpoints.',
    points: [
      {
        title: 'Brand assets',
        body: 'Visual kits, ad creative, social assets, presentation support, and design production for day-to-day marketing needs.',
      },
      {
        title: 'Conversion pages',
        body: 'Landing pages and promotional layouts designed to support campaigns, launches, and lead generation.',
      },
      {
        title: 'Systemized design',
        body: 'Repeatable templates and design standards that keep output consistent as your content volume increases.',
      },
    ],
  },
  platform: {
    eyebrow: 'Platform Development',
    title: 'Infrastructure for the systems your business runs on.',
    ctaLabel: 'Build Your Package',
    ctaTo: '/services/platform-development',
    lead:
      'Platform Development is for businesses that need more than surface-level design work, including custom websites, ecommerce builds, integrations, and internal tools.',
    points: [
      {
        title: 'Custom builds',
        body: 'Marketing sites, ecommerce storefronts, and application-style experiences built around real operational needs.',
      },
      {
        title: 'Connected systems',
        body: 'API integrations, automation workflows, and platform connections that reduce manual work across teams.',
      },
      {
        title: 'Scale readiness',
        body: 'Architecture, implementation, and iteration support designed for businesses that are growing beyond off-the-shelf setups.',
      },
    ],
  },
};
